import Rails from '@rails/ujs';

const hasManyRemoveClick = function (event) {
    event.preventDefault();
    const oldGroup = this.closest("fieldset.has-many-fields");
    if (oldGroup) {
        $(document).trigger('has_many_remove:before', [oldGroup, parent])
        oldGroup.remove();
        $(document).trigger('has_many_remove:after', [oldGroup, parent])
    }
};

Rails.delegate(document, "form .has-many-remove", "click", hasManyRemoveClick);

const hasManyAddClick = function (event) {
    event.preventDefault();
    const parent = this.closest(".has-many-container");
    $(parent).trigger('has_many_add:before', [parent]) // Aggiunta callback

    let index = parseInt(parent.dataset.has_many_index || (parent.querySelectorAll('fieldset').length - 1), 10);
    parent.dataset.has_many_index = ++index;

    const regex = new RegExp(this.dataset.placeholder, 'g');
    const html = this.dataset.html.replace(regex, index);

    const tempEl = document.createElement("div");
    tempEl.innerHTML = html;

    // Personalizzazione per valorizzare la posizione degli item
    let myIndex = parseInt(parent.dataset.myCounter);
    $(tempEl.firstChild).find('[id$=_position]').val(myIndex)
    parent.dataset.myCounter = ++myIndex;
    // Fine personalizzazione
    this.before(tempEl.firstChild);

    $(parent).trigger('has_many_add:after', [this.previousElementSibling, parent]) // Aggiunta callback

};

Rails.delegate(document, "form .has-many-add", "click", hasManyAddClick);
